import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import { editReceivingInvestigationFile2 } from "services/prosecutorPoliceService";
import { InvestigationFile } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";
import FileUpload from "./FileUpload";

interface Props {
  file: InvestigationFile;
  setRefetch: () => void;
  onCancel: () => void;
}

const EditDoesntCharge: React.FC<Props> = ({ file, onCancel, setRefetch }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = React.useState(false);

  const [formState, setFormState] = useState({
    decision_reason: "",
    decision_date: null as any,
    decision_file: null as File | null,
  });

  useEffect(() => {
    if (file) {
      setFormState({
        decision_reason: file?.decision_reason ?? "",
        decision_date:
          file?.decision_date !== undefined && file.decision_date !== null
            ? new Date(file.decision_date).toISOString().split("T")[0]
            : null,
        decision_file: null,
      });
    }
  }, [file]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.decision_reason)
      return "Petty Offence Decision Reason is required.";
    if (!formState.decision_date)
      return "Petty Offence Decision Date is required.";
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);
    const formData = {
      ...formState,
      id: file?.id,
      prosecutor_decision_type: "decision_not_to_charge",
      prosecutor_decision_status: "pending",
      decision_file: formState.decision_file
        ? formState.decision_file
        : undefined,
    };
    editReceivingInvestigationFile2(formData)
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        setRefetch();
        onCancel();
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  const handleFile = (name: string, file: File | null) => {
    setFormState({ ...formState, [name]: file });
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">
          Does not Institute of Charge Request
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="rounded-lg mt-4">
            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Reason
              </label>
              <textarea
                rows={3}
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="decision_reason"
                value={formState?.decision_reason ?? ""}
                onChange={handleChange}
              />
            </div>

            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Decision Date
              </label>
              <input
                type="date"
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="decision_date"
                value={
                  formState?.decision_date
                    ? new Date(formState.decision_date)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col mt-4 col-span-2">
              <FileUpload
                label="Decision File"
                fileTypes="*"
                required={true}
                onChange={(file) => handleFile("decision_file", file)}
              />
            </div>
          </div>
          <div className="mt-4 flex justify-between gap-2">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
              onClick={onCancel}
              type="button"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Edit Request"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDoesntCharge;
